(function () {
  if (typeof window === "undefined") return;

  function registerSharedAnimations() {
    if (typeof window.gsap === "undefined") return;
    if (typeof window.ScrollTrigger === "undefined") return;

    try {
      window.gsap.registerPlugin(window.ScrollTrigger);
    } catch (e) {
      // Ignore duplicate/late registration failures; runtime consumers fallback safely.
    }

    window.__svAnimationReady = true;
    document.dispatchEvent(new CustomEvent("sv:animation-ready"));
  }

  registerSharedAnimations();
})();
